module.exports = __webpack_public_path__ + "img/facebook.2204678f.svg";